import React from "react";
import { Approved } from '../Approved/Approved';
import { Rejected } from '../Rejected/Rejected';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Button } from 'antd';
import './Home.css';
import { withRouter } from "react-router";
import * as firebase from "firebase/app";

const fetchUserAnswersStatus = () => {}
class Home extends React.Component {
  startAssessment = () => {
    this.props.history.push('/qna');
  }
  getJsDate = (firebaseTimestamp) => {
    const dateObj = new firebase.firestore.Timestamp(firebaseTimestamp._seconds, firebaseTimestamp._nanoseconds).toDate();
    return `${dateObj.toDateString()} ${dateObj.toTimeString()}`;
  }
  render() {
    const metaInfo = {
      'living_in_containment_zone': {
        color: '#ffb2b2',
        image: 'virus.png'
      },
      'will_you_travel': {
        color: '#beb2ff',
        image: 'maintain_social_distancing.png'
      },
      default: {
        color: '#ffb2b2',
        image: 'virus.png'
      }
    }
    const currentUser = firebase.auth().currentUser;
    const successQnaMessage = this.props.metaData ? this.props.metaData.messages.qna_success : '';
    const failedQnaMessage = this.props.metaData ? this.props.metaData.messages.qna_failure : '';
    const notStartedQnaMessage = this.props.metaData ? this.props.metaData.messages.qna_not_started : '';
    const assessmentDate = this.props.homescreenData && this.props.homescreenData.assessmentDate ? this.getJsDate(this.props.homescreenData.assessmentDate) : '';
    let dateStr;
    if (assessmentDate) {
      dateStr = new Date(assessmentDate).toDateString();
    }

    return (
      <div className="homeContainer">
        {
          this.props.assessmentStatus === 'success' &&
          <Approved
            message={successQnaMessage}
            dateStr={dateStr}
            displayName={currentUser.displayName}
          />
        }
        {
          this.props.assessmentStatus === 'failure' &&
          <Rejected message={failedQnaMessage} />
        }
        {
          this.props.homescreenData &&
          this.props.homescreenData.errorMessages &&
          this.props.homescreenData.errorMessages.length > 0 &&
          this.props.homescreenData.errorMessages.map((message, index) => {
            const messageMeta = metaInfo[message.identifier] || metaInfo.default;
            return (
              <div className="messageContainer" key={index}>
                <p
                  className="message"
                  style={{
                    backgroundColor: messageMeta.color,
                  }}>
                  {message.message}</p>
                  {/* <img className="image" src={require(`../../assets/images/${messageMeta.image}`)} alt=""/> */}
              </div>
            );
          })
        }
        {
          (
            this.props.assessmentStatus === 'failure' ||
            this.props.assessmentStatus === 'failure'
          ) &&
          <div className="retakeAssessment" onClick={this.startAssessment}>
            Retake Assessment
          </div>
        }
        {
          this.props.assessmentStatus === 'not_started' &&
          <div className="takeAssessmentInfo">
            <p className="startAssessmentMessage">{notStartedQnaMessage}</p>
            <Button onClick={this.startAssessment} className="startAssessmentCta">Start Assessment</Button>
          </div>
        }
        {
          !!this.props.assessmentStatus &&
          <>
            <h1 className="heading">Stay safe and healthy</h1>
            <div className="imagesScrollContainer">
              <div className="divToHideScroll">
                <div className="contentDiv">
                  <div className="block">
                    <img className="image" src={require(`../../assets/images/maintain_social_distancing.png`)} alt=""/>
                    <p>Maintain social distancing</p>
                  </div>
                  <div className="block">
                    <img className="image" src={require(`../../assets/images/wash_hands.png`)} alt=""/>
                    <p>Wash hands thoroughly</p>
                  </div>
                  <div className="block">
                    <img className="image" src={require(`../../assets/images/wear_mask.png`)} alt=""/>
                    <p>Use a face mask</p>
                  </div>
                  <div className="block">
                    <img className="image" src={require(`../../assets/images/use_sanitizer.png`)} alt=""/>
                    <p>Use hand sanitizer regularly</p>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
      </div>
    );
  }
}

export default connect(
  (state) => ({
    assessmentStatus: state.userReducer.assessmentStatus,
    homescreenData: state.userReducer.homescreenData,
    metaData: state.userReducer.metaData,
  }),
  (dispatch) => bindActionCreators({ fetchUserAnswersStatus }, dispatch)
)(withRouter(Home));
